import React from 'react';
import StaticPageLayout from '@/components/layout/StaticPageLayout';
const AboutPage = () => {
  return <StaticPageLayout title="Our Story" description="Discover the journey and vision behind Everhouse">
      <section className="mb-12">
        <h2 className="mb-4 text-2xl font-normal">Who We Are</h2>
        <p className="mb-4 leading-article">
          Everhouse is a leading digital platform dedicated to exploring and celebrating 
          the intersection of lifestyle, culture, and innovation. Founded with a vision 
          to create meaningful connections through compelling storytelling, we've grown 
          into a global community of passionate individuals who share our curiosity 
          about the world.
        </p>
        <p className="leading-article">
          Our commitment to quality journalism and authentic storytelling has made us 
          a trusted voice in the digital landscape, connecting audiences with the stories 
          that matter most.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl mb-4 font-normal">Our Mission</h2>
        <p className="leading-article">
          To inspire and inform through exceptional storytelling, fostering a community 
          that celebrates creativity, innovation, and cultural exploration. We believe 
          in the power of authentic narratives to connect people and ideas across 
          the globe.
        </p>
      </section>

      
    </StaticPageLayout>;
};
export default AboutPage;